import { ISitePage } from "./types";

export const pages: ISitePage[] = [
    // { element: <></>, link: "", sidebarLabel: "" },
];
